import { render, staticRenderFns } from "./Accepted.vue?vue&type=template&id=470923f6&scoped=true"
import script from "./Accepted.vue?vue&type=script&lang=js"
export * from "./Accepted.vue?vue&type=script&lang=js"
import style0 from "./Accepted.vue?vue&type=style&index=0&id=470923f6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470923f6",
  null
  
)

export default component.exports